
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/topik/[topik]",
      function () {
        return require("private-next-pages/pelatihan-mandiri/topik/[topik]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/topik/[topik]"])
      });
    }
  